import React, { Ref } from 'react'

import { ImageWrapper } from '../../components/Game/Image/styles/ImageWrapper'
import Wrapper from '../../components/Game/styles/GameWrapper'

interface Props {
  innerRef?: Ref<any>
}

export default function GameBoxFallback({ innerRef }: Props) {
  return (
    <Wrapper ref={innerRef}>
      <ImageWrapper />
    </Wrapper>
  )
}
